module.exports = __webpack_public_path__ + "img/01.d50f7a52.jpg";